import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sam4-knowledge-base-not-authorized',
    templateUrl: './knowledge-base-not-authorized.component.html',
    styleUrls: ['./knowledge-base-not-authorized.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class KnowledgeBaseNotAuthorizedComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
